// SPDX-License-Identifier: AGPL-3.0-or-later

import {Routes} from '@app/app/Routes';
import * as Modal from '@app/features/app/components/dialogs/Modal';
import styles from '@app/features/auth/components/modals/AccountDisableModal.module.css';
import * as RouterUtils from '@app/features/navigation/utils/RouterUtils';
import {Button} from '@app/features/ui/button/Button';
import * as ModalCommands from '@app/features/ui/commands/ModalCommands';
import * as UserCommands from '@app/features/user/commands/UserCommands';
import * as FormUtils from '@app/lib/forms';
import {Trans, useLingui} from '@lingui/react/macro';
import {observer} from 'mobx-react-lite';
import {useState} from 'react';
export const AccountDisableModal = observer(() => {
	const {t, i18n} = useLingui();
	const [isSubmitting, setIsSubmitting] = useState(false);
	const handleConfirm = async () => {
		setIsSubmitting(true);
		try {
			await UserCommands.disableAccount();
			ModalCommands.pop();
			RouterUtils.transitionTo(Routes.LOGIN);
		} catch (error) {
			FormUtils.pushApiErrorModal(i18n, error);
		} finally {
			setIsSubmitting(false);
		}
	};
	return (
		<Modal.Root size="small" centered>
			<Modal.Header title={t`Disable Account`} />
			<Modal.Content contentClassName={styles.content}>
				<div className={styles.description}>
					<Trans>
						Disabling your account will log you out of all sessions. You can re-enable your account at any time by
						logging in again.
					</Trans>
				</div>
			</Modal.Content>
			<Modal.Footer>
				<Button onClick={ModalCommands.pop} variant="secondary">
					<Trans>Cancel</Trans>
				</Button>
				<Button onClick={handleConfirm} submitting={isSubmitting} variant="danger-primary">
					<Trans>Disable Account</Trans>
				</Button>
			</Modal.Footer>
		</Modal.Root>
	);
});
